import React from "react";
import { Container, Row, Col, Card, ButtonGroup, Button, InputGroup, Form } from "react-bootstrap";
import LessonCard from "../../components/LessonCard/LessonCard";
import { Line } from "react-chartjs-2";
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
const Joinexam = () => {

  return (
    <Container fluid className="p-4 px-0 ">
      <div className="d-lg-flex justify-content-between align-items-center">
        <Link to="/exammanagement" className="text-decoration-none text-dark"> <div>   <h4 className="mb-3 font-18 fw-bold d-flex align-items-center"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.373 12.75L13.0693 18.4462L12 19.5L4.5 12L12 4.5L13.0693 5.55375L7.373 11.25H19.5V12.75H7.373Z" fill="#1F1F1F" />
        </svg>&nbsp;
        Back</h4></div></Link>
       
      </div>

      <LessonCard />
      <Row className="text-center">
        <div className="text-center">
         </div>
      </Row>


    </Container>
  );
};

export default Joinexam;